import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Text, Form, Item, Label, Input, H3, Content, CardItem, Card } from "native-base";

import { connect } from 'react-redux';
import { styles } from '../../constants';

import {
    sendEmailConfirm,
    setCurrentAction
} from '../../actions/';


class EmailConfirm extends Component {
    state = {
        email: this.props.email,
        code: this.props.code
    };

    onChangeInput = (key, e) => this.setState({ [key]: e.target.value });

    handlerSubmit = () => {
        const { dispatch } = this.props;
        dispatch(sendEmailConfirm(this.state));
    };

    handlerClickLogin = (event) => {
        const { dispatch } = this.props;
        event.preventDefault();
        dispatch(setCurrentAction('login'));
    };

    handlerClickGetEmailConfirm = (event) => {
        const { dispatch } = this.props;
        event.preventDefault();
        dispatch(setCurrentAction('getconfirm'));
    };

    render() {
        const { authCause, currentAction } = this.props;
        const { email, code } = this.state;

        return <Content style={styles.content}>
            <Form>
                <H3 style={styles.appDescription}>Подтверждение регистрации</H3>
                {currentAction === 'confirmSuccess' ? <Text>Регистрация подтверждена. Теперь Вы можете войти в систему.</Text> :
                    <>
                        <Item stackedLabel>
                            <Label>Email*</Label>
                            <Input
                                keyboardType="email-address"
                                onChange={(e) => this.onChangeInput('email', e)}
                                value={email}
                            />
                        </Item>
                        <Item stackedLabel>
                            <Label>Код подтверждения*</Label>
                            <Input
                                onChange={(e) => this.onChangeInput('code', e)}
                                value={code}
                            />
                        </Item>
                        <Button
                            large
                            full
                            rounded
                            onPress={this.handlerSubmit}
                            style={styles.button}
                        >
                            <Text>Подтвердить</Text>
                        </Button>
                    </>}
                <Button transparent block style={styles.bottomLink} onPress={this.handlerClickLogin}>
                    <Text>Вход</Text>
                </Button>
                <Button transparent block style={styles.bottomLink} onPress={this.handlerClickGetEmailConfirm}>
                    <Text>Выслать повторный код подтверждения</Text>
                </Button>
                {authCause ? <Card>
                    <CardItem>
                        <Text>{authCause}</Text>
                    </CardItem>
                </Card> : null}
            </Form>
        </Content>;
    }
}

EmailConfirm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    authCause: PropTypes.string,
    currentAction: PropTypes.string,
    email: PropTypes.string,
    code: PropTypes.string
};

EmailConfirm.defaultProps = {
    authCause: '',
};

const mapStateToProps = (state) => ({
    authCause: state.authCause,
});

export default connect(mapStateToProps)(EmailConfirm);
